// planLimits.js (frontend) — UI-DISPLAY-ONLY mirror of the plan-tier limits enforced server-side
// in amplify/backend/function/{storeuserdata,scheduledPodcastGenerator}/src/planLimits.js.
// The backend is the source of truth; this exists only so the UI can show accurate copy and
// disable controls before a user hits a 400 from the API. Keep numbers in sync manually.
//
//   epsPerDay       — max episodes generated per UTC day (the daily generation cap)
//   maxSchedules    — max non-deleted schedules per user
//   maxRefreshTimes — max refresh times per schedule
//   maxDailyRuns    — max enabled scheduled run opportunities per day (sum of refreshTimes
//                     across active, non-deleted schedules)
//   maxArticlesPerSource     — max articles pulled per news source for a scheduled episode
//   defaultArticlesPerSource — default article count applied when a schedule omits the field

export const PLAN_LIMITS = {
  free: { epsPerDay: 1,  maxSchedules: 1, maxRefreshTimes: 2, maxDailyRuns: 1, maxArticlesPerSource: 3,  defaultArticlesPerSource: 3 },
  plus: { epsPerDay: 3,  maxSchedules: 3, maxRefreshTimes: 2, maxDailyRuns: 3, maxArticlesPerSource: 10, defaultArticlesPerSource: 3 },
  comp: { epsPerDay: 10, maxSchedules: 6, maxRefreshTimes: 2, maxDailyRuns: 6, maxArticlesPerSource: 15, defaultArticlesPerSource: 3 },
};

// getPlanLimits(plan) — always returns a limits object; unknown/missing plan falls back to free.
export function getPlanLimits(plan) {
  return PLAN_LIMITS[plan] || PLAN_LIMITS.free;
}
